import { AnyAction } from 'redux';
import * as actionTypes from '../../../../models/actionTypes';
import {
  initialRequestFeedbackState,
  IRequestFeedbackState,
} from '../../../../models/reduxState';
import { RequestFeedbackSchema, RequestFeedbackSubmitStatus } from '../../models/feedbackModels';

// For non-Agave (InApp) and Outlook.com
const handleSupportDataGrabSuccess = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  return {
    ...state,
    isRequestFeedbackEnabled: !!action.supportSettingsConfig && action.supportSettingsConfig.IsRequestFeedbackEnabled,
    requestFeedbackCommentMaxLength: !!action.supportSettingsConfig ? action.supportSettingsConfig.RequestFeedbackCommentMaxLength : 1000,
  };
};

// For all entry points other than non-Agave (InApp) and Outlook.com
const handleSocDataGrabSuccess = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  return {
    ...state,
    isRequestFeedbackEnabled: !!action.supportSettingsConfig && action.supportSettingsConfig.IsRequestFeedbackEnabled,
    requestFeedbackCommentMaxLength: !!action.supportSettingsConfig ? action.supportSettingsConfig.RequestFeedbackCommentMaxLength : 1000,
  };
};

export const handleSubmitFeedback = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  const allRequestFeedback = state.allRequestFeedback ? [...state.allRequestFeedback] : [];
  const requestIndex = getRequestFeedbackIndexByRequestId(allRequestFeedback, action.requestId);
  if (requestIndex !== -1) {
    allRequestFeedback[requestIndex].IsProcessing = true;
  }
  return { ...state, allRequestFeedback };
};

export const handleSubmitFeedbackSuccuss = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  const allRequestFeedback = state.allRequestFeedback ? [...state.allRequestFeedback] : [];
  const requestIndex = getRequestFeedbackIndexByRequestId(allRequestFeedback, action.requestId);
  if (requestIndex !== -1) {
    allRequestFeedback[requestIndex].IsProcessing = false;
    allRequestFeedback[requestIndex].RequestFeedbackSubmitStatus = RequestFeedbackSubmitStatus.Success;
  }
  return { ...state, allRequestFeedback };
};

export const handleSubmitFeedbackError = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  const allRequestFeedback = state.allRequestFeedback ? [...state.allRequestFeedback] : [];
  const requestIndex = getRequestFeedbackIndexByRequestId(allRequestFeedback, action.requestId);
  if (requestIndex !== -1) {
    allRequestFeedback[requestIndex].IsProcessing = false;
    allRequestFeedback[requestIndex].RequestFeedbackSubmitStatus = RequestFeedbackSubmitStatus.Error;
  }
  return { ...state, allRequestFeedback };
};

const handleUpdateFeedback = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  const allRequestFeedback = state.allRequestFeedback ? [...state.allRequestFeedback] : [];
  const requestIndex = getRequestFeedbackIndexByRequestId(allRequestFeedback, action.requestFeedbackSchema.RequestId);
  if (requestIndex !== -1) {
    const newFeedback = new RequestFeedbackSchema();
    newFeedback.RequestId = action.requestFeedbackSchema.RequestId;
    newFeedback.Rating = action.requestFeedbackSchema.Rating;
    newFeedback.RatingText = action.requestFeedbackSchema.RatingText;
    newFeedback.RequestFeedbackSubmitStatus = action.requestFeedbackSchema.RequestFeedbackSubmitStatus;
    newFeedback.IsProcessing = action.requestFeedbackSchema.IsProcessing;
    newFeedback.IssueResolved = action.requestFeedbackSchema.IssueResolved;
    newFeedback.Comment = action.requestFeedbackSchema.Comment;
    newFeedback.SurveyCheckBoxes = action.requestFeedbackSchema.SurveyCheckBoxes;
    newFeedback.IsFeedbackCategoriesVisible = action.requestFeedbackSchema.IsFeedbackCategoriesVisible;
    allRequestFeedback[requestIndex] = newFeedback;
  }
  return { ...state, allRequestFeedback };
};

const handleResetFeedback = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  const allRequestFeedback = state.allRequestFeedback ? [...state.allRequestFeedback] : [];
  const requestIndex = getRequestFeedbackIndexByRequestId(state.allRequestFeedback, action.requestId);
  const newFeedback = new RequestFeedbackSchema();
  newFeedback.RequestId = action.requestId;
  if (requestIndex !== -1) {
    allRequestFeedback[requestIndex] = newFeedback;
  } else {
    allRequestFeedback.push(newFeedback);
  }
  return { ...state, allRequestFeedback };
};

export const RequestFeedbackReducer = (
  state: IRequestFeedbackState = initialRequestFeedbackState,
  action: AnyAction
): IRequestFeedbackState => {
  switch (action.type) {
    case actionTypes.GET_EMERALD_SUPPORTCONFIG_SUCCESS:
      return handleSupportDataGrabSuccess(state, action);
    case actionTypes.GET_EMERALD_CONFIG_SUCCESS:
      return handleSocDataGrabSuccess(state, action);
    case actionTypes.UPDATE_FEEDBACK:
      return handleUpdateFeedback(state, action);
    case actionTypes.RESET_FEEDBACK:
      return handleResetFeedback(state, action);
    case actionTypes.SUBMIT_FEEDBACK:
      return handleSubmitFeedback(state, action);
    case actionTypes.SUBMIT_FEEDBACK_SUCCESS:
      return handleSubmitFeedbackSuccuss(state, action);
    case actionTypes.SUBMIT_FEEDBACK_ERROR:
      return handleSubmitFeedbackError(state, action);
    default:
      return state;
  }
};

const getRequestFeedbackIndexByRequestId = (allRequestFeedbacks: RequestFeedbackSchema[], requestId: string): number => {
  let index = -1;
  allRequestFeedbacks.map((requestFeedback: RequestFeedbackSchema, key: number) => {
    if (!!requestFeedback.RequestId &&
      !!requestId &&
      requestFeedback.RequestId.toLocaleLowerCase() === requestId.toLowerCase()) {
      index = key;
    }
  });
  return index;
};
